export const KEY_AUTH_TOKEN = "auth-token"
export const USER_DATA = "user-data"
